import _ from 'lodash';
import { connect } from 'react-redux';
import { withRouter, RouteComponentProps } from 'react-router-dom';

import { IApplicationState } from '@store';
import { OrderWithSamples } from '@models';

import OrderDetail, {
  OrderDetailProps,
} from '../components/orders/OrderDetail';

type IMapStateToProps = Pick<IApplicationState, 'orders'>;

type OwnProps = RouteComponentProps<{
  orderNumber: string;
}>;

const mapStateToProps = (
  { orders }: IMapStateToProps,
  ownProps: OwnProps
): OrderDetailProps => {
  const orderNumber = ownProps.match.params.orderNumber;
  const order = _.find(orders.orders, function (o: OrderWithSamples) {
    return o.orderNumber === orderNumber;
  });

  return {
    orderNumber: orderNumber,
    order: order,
  };
};

export default withRouter(connect(mapStateToProps)(OrderDetail));
